module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-08.3eb12dcc.jpg";